export default "__VITE_ASSET__Bc9P2dXt__"